import {
  put,
  call,
  takeEvery } from 'redux-saga/effects';
import { showNotification } from '../../notifications/actions';
import { parseApiError } from '../../util/api';
import { fetchOrgSuccess } from '../orgAdmin/actions';
import { INTEGRATION_SYNC_AGRIWEBB, INTEGRATION_SYNC_BCMS } from './constants';
import IntegrationsAPI from './IntegrationsAPI';

function * syncBCMS (action) {
  try {
    const { data } = yield call(IntegrationsAPI.syncBCMS, action.org);
    if (data && data.taskId) {
      yield put(showNotification(
        'BCMS sync started', `task ID: ${data.taskId}`, 'info', 10
      ));
    }
    if (data && data.org) {
      yield put(fetchOrgSuccess(data.org));
    }
  } catch (error) {
    const msg = parseApiError(error);
    yield put(showNotification(
      'BCMS sync failed', msg, 'error', 10
    ));
  }
}

function * syncAgriwebb (action) {
  try {
    const { data } = yield call(IntegrationsAPI.syncAgriwebb, action.org);
    if (data && data.taskId) {
      yield put(showNotification(
        'Agriwebb sync started', `task ID: ${data.taskId}`, 'info', 10
      ));
    }
    if (data && data.org) {
      yield put(fetchOrgSuccess(data.org));
    }
  } catch (error) {
    const msg = parseApiError(error);
    yield put(showNotification(
      'Agriwebb sync failed', msg, 'error', 10
    ));
  }
}

function * integrationSagas () {
  yield takeEvery(INTEGRATION_SYNC_BCMS, syncBCMS);
  yield takeEvery(INTEGRATION_SYNC_AGRIWEBB, syncAgriwebb);
};

export default integrationSagas;
